(function() {
  function removeSticky() {
    document.querySelectorAll(".iframe-frontrow-sticky").forEach(function(el) { el.remove(); });
  }
  var observer = new MutationObserver(removeSticky);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", removeSticky);
})();

document.addEventListener("DOMContentLoaded", () => {
  // Move chat widget up when #alia-root-111460 is visible (element loads dynamically)
  const waitForAlia = new MutationObserver(() => {
    const aliaRoot = document.getElementById("alia-root-111460");
    if (!aliaRoot) return;
    waitForAlia.disconnect();

    const checkAlia = () => {
      const visible = window.getComputedStyle(aliaRoot).display !== "none";
      document.body.classList.toggle("c-alia-visible", visible);
    };
    checkAlia();
    new MutationObserver(checkAlia).observe(aliaRoot, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  });
  waitForAlia.observe(document.body, { childList: true, subtree: true });

});


// FrontRow Modal - Lock background scroll when modal is open
(function () {
  function checkModalState(iframe) {
    if (iframe.style.display === 'block') {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  function watchModalIframe(iframe) {
    checkModalState(iframe);
    new MutationObserver(function () {
      checkModalState(iframe);
    }).observe(iframe, { attributes: true, attributeFilter: ['style'] });
  }

  function onPortalReady(portal) {
    portal.querySelectorAll('iframe[class*="iframe-modal-frontrow"]').forEach(watchModalIframe);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.tagName === 'IFRAME' && node.className.includes('iframe-modal-frontrow')) {
            watchModalIframe(node);
          }
        });
      });
    }).observe(portal, { childList: true });
  }

  function init() {
    var portal = document.getElementById('frontrow-portal');
    if (portal) {
      onPortalReady(portal);
    } else {
      new MutationObserver(function (_mutations, obs) {
        var portal = document.getElementById('frontrow-portal');
        if (portal) {
          obs.disconnect();
          onPortalReady(portal);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();